import React from "react";
import './faq.css';
import Accord from './Accord';
import BottomBox from './BottomBox';
import Pop from './Pop';

import Helmet from 'react-helmet';
import Box from '@mui/material/Box';
import { withRouter } from 'react-router-dom';



 
function Faq(props){
    const { history } = props;
    return ( 
        <div className="faq__main">
        
        <Pop/>
        <Box 
             sx = {theme => ({ [theme.breakpoints.up('sm')]:{backgroundColor:'#202020',width:'100%',height:'50vh',maxHeight:'50%'},
             [theme.breakpoints.between('0','600')]:{backgroundColor:'#202020',width:'100%',height:'35vh',maxHeight:'50%'}
             })}
        
        />
            
            <p onClick={()=> history.push('/')} className="faq__head">Untouched</p>
            <div className='faq'>
             <p>FAQ's</p> 
            </div>
           
        
        
       
            <Accord/> 
           
            <BottomBox/>
       
        
        </div>
        
        );
}
 
export default withRouter(Faq);